import React, { Component } from 'react'
import { connect } from 'react-redux'
import { lifecycle, compose, nest, withState, withHandlers } from 'recompose'
import T from 'i18n-react'
import injectSagas from 'helpers/injectSagas'

import styles from './styles.scss'

import Card from './Card'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'
import Divider from 'components/fulcrum/divider/Divider'
import Actions from './Actions'

import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'

import LastUpdated from 'components/display/LastUpdated'

import { fetchProjectWorkflowDetails, postWorkflowState } from './actions'
import { MODULE_NAME } from './constants'
import sagas from './sagas'
import { 
  projectWorkflowDetailsLastUpdatedDateSelector, 
  projectWorkflowDetailsLastUpdatedNameSelector, 
  projectWorkflowIdSelector,
  projectIdSelector,
  projectWorkflowStateToChangeToSelector,
  projectWorkflowHistorySelector,
  saveDisabledSelector
} from './selectors'

import LifecycleBody from './LifecycleBody'
import InfoDialog from './InfoDialog'


const mapStateToProps = state => {
  return {
    lastUpdatedDate: projectWorkflowDetailsLastUpdatedDateSelector(state),
    lastUpdatedName: projectWorkflowDetailsLastUpdatedNameSelector(state),
    projectWorkflowId: projectWorkflowIdSelector(state),
    history: projectWorkflowHistorySelector(state),
    projectId: projectIdSelector(state),
    stateToChangeTo: projectWorkflowStateToChangeToSelector(state),
    saveDisabled: saveDisabledSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchProjectWorkflowDetails: (projectId) => dispatch(fetchProjectWorkflowDetails(projectId)),
    postWorkflowState: (projectId, workflowId, state) => dispatch(postWorkflowState(projectId, workflowId, state))
  }
}

class LifecycleCard extends Component {

  onSave() {
    this.props.postWorkflowState(this.props.projectId, this.props.projectWorkflowId, this.props.stateToChangeTo)
  }

  render() {
    const {
      history,
      collapse,
      toggleCollapse,
      edit,
      toggleEdit,
      dialogActive,
      toggleDialogActive,
      lastUpdatedDate,
      lastUpdatedName,
      saveDisabled
    } = this.props

    return (
      <Card>
        <InfoDialog
          active={dialogActive}
          toggleActive={toggleDialogActive}
          lifecycleHistory={history}
        />
        <CardHeader title={T.translate('containers.project.lifecycleSection.index.header')}>
          <Actions
            collapse={collapse}
            toggleCollapse={toggleCollapse}
            edit={edit}
            toggleEdit={toggleEdit}
            onSave={() => this.onSave()}
            toggleDialogActive={toggleDialogActive}
            disabled={saveDisabled}
          />
        </CardHeader>
        <LastUpdated name={lastUpdatedName} date={lastUpdatedDate} />
        <Divider className={styles.divider}/>
        <Collapse collapse={collapse}>
          <LifecycleBody edit={edit}/>
        </Collapse>
      </Card>
    )
  }
}

const LifecycleSection = nest(Section, LifecycleCard)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: sagas})
const withEditState = compose(
  withState('edit', 'changeEdit', false),
  withHandlers({
    toggleEdit: ({changeEdit}) => () => changeEdit(e => !e)
  })
)

const withDialogState = compose(
  withState('dialogActive', 'changeDialogActive', false),
  withHandlers({
    toggleDialogActive: ({changeDialogActive}) => () => changeDialogActive(e => !e)
  })
)

const enhance = compose(
  withSagas,
  withConnect,
  withCollapse,
  withEditState,
  withDialogState,
  lifecycle({
    componentWillMount() { 
      const {fetchProjectWorkflowDetails, id} = this.props
      fetchProjectWorkflowDetails(id)
    },
    componentWillUnmount() { }
  })
)

export default enhance(LifecycleSection)
